import store from '../../store';
import SidebarCartItem from './SidebarCartItem.vue';
import {currencyFormat} from "../../functions";

export default {
    components: { SidebarCartItem },

    computed: {
        cart() {
            return store.state.cart;
        },

        cartIsEmpty() {
            return store.cartIsEmpty();
        },

        cartIsNotEmpty() {
            return ! store.cartIsEmpty();
        },
    },

    data() {
        return {
            currencyFormat
        }
    }
};
